export default __webpack_public_path__ + "static/media/x.fb57a3bd.svg";